import React from 'react';
import styles from './Logo.module.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'light' | 'dark' | 'auto';
  showText?: boolean;
  className?: string;
}

export const Logo: React.FC<LogoProps> = ({
  size = 'medium',
  variant = 'auto',
  showText = true,
  className = '',
}) => {
  return (
    <div
      className={`${styles.logo} ${styles[size]} ${styles[variant]} ${
        !showText ? styles.logoOnly : ''
      } ${className}`}
    >
      <div className={styles.logoIcon}>
        {/* Placeholder logo - replace with actual logo later */}
        <svg
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className={styles.logoSvg}
        >
          {/* Geometric shader-like pattern */}
          <rect
            width="40"
            height="40"
            rx="8"
            fill="currentColor"
            fillOpacity="0.1"
          />
          <path
            d="M8 12L20 8L32 12L20 32L8 12Z"
            fill="currentColor"
            fillOpacity="0.8"
          />
          <path
            d="M12 16L20 12L28 16L20 28L12 16Z"
            fill="currentColor"
            fillOpacity="0.6"
          />
          <circle cx="20" cy="18" r="4" fill="currentColor" />
        </svg>
      </div>
      {showText && <span className={styles.logoText}>Shadeables</span>}
    </div>
  );
};
